import { useEffect } from "react";

export const CLOSE_ALL_MODALS_EVENT = "chuzi:close-all-modals";

export function dispatchCloseAllModals() {
  window.dispatchEvent(new CustomEvent(CLOSE_ALL_MODALS_EVENT));
}

export function useCloseAllModalsListener(handler: () => void) {
  useEffect(() => {
    window.addEventListener(CLOSE_ALL_MODALS_EVENT, handler);
    return () => window.removeEventListener(CLOSE_ALL_MODALS_EVENT, handler);
  }, [handler]);
}
